import React, { useState, useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { languageService } from "./lang/Lang.js";

// Import Terms JSON files
import termsDefaultEn from './legal/terms-default-en.json';
import termsDefaultAr from './legal/terms-default-ar.json';
import termsDefaultDe from './legal/terms-default-de.json';
import termsUaeEn from './legal/terms-uae-en.json';
import termsUaeAr from './legal/terms-uae-ar.json';
import termsUaeDe from './legal/terms-uae-de.json';

const API_URL = process.env.REACT_APP_API_URL || 'https://sahra.ai/api';

export default function Terms() {
  const [termsContent, setTermsContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTerms = async () => {
      try {
        // Get user language
        const lang = (languageService.getLanguage() || 'en').toLowerCase();
        const isArabic = lang.startsWith('ar');
        const isGerman = lang.startsWith('de');

        // Check for URL parameter override (for testing)
        const urlParams = new URLSearchParams(window.location.search);
        const countryOverride = urlParams.get('country');

        // Fetch country from geo endpoint
        let country = 'XX';
        if (countryOverride) {
          // Use URL override if provided
          country = countryOverride.toUpperCase();
        } else {
          try {
            const response = await fetch(`${API_URL}/geo`);
            const data = await response.json();
            country = data.country || 'XX';
          } catch (geoError) {
            console.warn('Geo lookup failed, using default terms:', geoError);
          }
        }

        // Select appropriate Terms based on country and language
        let terms;
        if (country === 'AE') {
          // UAE jurisdiction
          if (isArabic) terms = termsUaeAr;
          else if (isGerman) terms = termsUaeDe;
          else terms = termsUaeEn;
        } else {
          // Default (Spain jurisdiction)
          if (isArabic) terms = termsDefaultAr;
          else if (isGerman) terms = termsDefaultDe;
          else terms = termsDefaultEn;
        }

        setTermsContent(terms.terms);
      } catch (error) {
        console.error('Error loading terms:', error);
        // Fallback to default English terms
        setTermsContent(termsDefaultEn.terms);
      } finally {
        setLoading(false);
      }
    };

    loadTerms();
  }, []);

  if (loading) {
    return (
      <div style={{ padding: '60px 20px', textAlign: 'center' }}>
        Loading...
      </div>
    );
  }

  return <div>{ReactHtmlParser(termsContent)}</div>;
}
